import { render, staticRenderFns } from "./ProductItemNext.vue?vue&type=template&id=6a3c3423"
import script from "./ProductItemNext.vue?vue&type=script&lang=js"
export * from "./ProductItemNext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports